<template>
  <div>
    <template v-if="loading">
      <wa-spinner />
    </template>
    <template v-else-if="ready">
      <NoteOrigin :item="data" />
    </template>
    <template v-else>
      <wa-callout variant="warning">
        <wa-icon library="bootstrap" slot="icon" name="exclamation-triangle-fill"></wa-icon>
        <p>{{ $t('note_item.appointment.load_failed') }}</p>
      </wa-callout>
    </template>
  </div>
</template>

<script setup>
import '@awesome.me/webawesome/dist/components/spinner/spinner.js'
import '@awesome.me/webawesome/dist/components/callout/callout.js'

import NoteOrigin from '@/components/shared/NoteOrigin/NoteOrigin.vue'

import _slugify from 'slugify'

import { onMounted, ref } from 'vue'

import { useI18n } from 'vue-i18n'
import { useTimify } from '@/composables/useTimify.js'
import { useAppointmentsStore } from '@/stores/appointments.js'

const props = defineProps({
  appointment: {
    type: Object,
    required: true
  }
})

const { t } = useI18n()
const timify = useTimify()
const appointmentsStore = useAppointmentsStore()

const loading = ref(true)
const ready = ref(false)
const data = ref(null)

onMounted(async () => {
  if (props.appointment) {
    try {
      const response = await timify.appointment({
        appointmentId: props.appointment.id,
        companyId: props.appointment.company_id
      })
      const [booking] = response?.data?.bookings || [{}]
      const { interval } = booking
      if (interval) {
        const date = new Date(interval.begin)
        const title = [
          appointmentsStore.appointmentTitleFixByService(slugify(response.data.title)),
          t('appointments.duration_title', { duration: response.data.duration })
        ].join(' ')
        const company = await appointmentsStore.getCompanyById(props.appointment.company_id)

        data.value = {
          date,
          title,
          company: company.externalId
        }
        ready.value = true
      }
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }
})

function slugify(name, options = {}) {
  return _slugify(name, {
    lower: true,
    remove: /[./\\()]/,
    locale: 'de',
    ...options
  }).replace(/-/g, '_')
}
</script>

<style scoped src="./Appointment.css"></style>
